import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';

const WorkflowTabs = ({ currentTab, onTabChange }) => {
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 0, pt: 0, px: 2, pb: 0 }}>
      <Tabs value={currentTab} onChange={onTabChange} aria-label="project workflow tabs">
        <Tab label="Ideation" sx={{ textTransform: 'none', fontSize: '0.875rem' }} />
        <Tab label="Design Process" sx={{ textTransform: 'none', fontSize: '0.875rem' }} />
        <Tab label="Verification" sx={{ textTransform: 'none', fontSize: '0.875rem' }} />
        <Tab label="Validation" sx={{ textTransform: 'none', fontSize: '0.875rem' }} />
        <Tab label="Design Transfer" sx={{ textTransform: 'none', fontSize: '0.875rem' }} />
      </Tabs>
    </Box>
  );
};

export default WorkflowTabs;
